import { type FC } from "react";
import { AppBar, Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useComplianceEnabled } from "@/partner/features/compliance";
import { usePlatformFeature } from "@/partner/entities/platforms";
import { PlatformFeatureType } from "@/types/graphql/partner.generated";

// Порт референсного VideoForm/Menu/Menu.js: вкладки формы видео
// («Редактирование» / «Метки»; субтитры — в бэклоге). Активная вкладка живёт
// в query-параметре ?tab= — как в референсе (searchParams.set("tab", name)).
export const VideoTabsMenu: FC<{ tab: string }> = ({ tab }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const complianceEnabled = useComplianceEnabled();
  // Вкладка «Опросы» только при фичефлаге админа PLAYER_POLLS.
  const pollsEnabled = usePlatformFeature(PlatformFeatureType.PlayerPollsType);

  const items = [
    { name: "edit", label: t("videos.tabs.edit") },
    { name: "timecodes", label: t("videos.tabs.timecodes") },
    ...(pollsEnabled ? [{ name: "polls", label: t("videos.tabs.polls") }] : []),
    // Записи 2257 показываем только на платформах с включённым комплаенсом
    // и только admin организации (см. useComplianceEnabled). На остальных
    // состав вкладок не меняется.
    ...(complianceEnabled
      ? [{ name: "records2257", label: t("compliance.tab") }]
      : []),
  ];

  // ?tab= приходит из адреса: на платформе без комплаенса записи 2257 в
  // items не попадают, и MUI ругался бы на value вне набора вкладок.
  const value = items.some((item) => item.name === tab) ? tab : false;

  return (
    <AppBar position="static" color="default" elevation={0}>
      <Tabs value={value} scrollButtons="auto" variant="scrollable">
        {items.map(({ name, label }) => (
          <Tab
            key={name}
            value={name}
            label={label}
            onClick={() => {
              searchParams.set("tab", name);
              setSearchParams(searchParams);
            }}
          />
        ))}
      </Tabs>
    </AppBar>
  );
};
